import { trackPageView } from './pageTracking';

window.mixpanel.init(window.mixpanelKey, { 
  debug: true, 
  track_pageview: false, // We'll handle this manually for more control
  persistence: 'localStorage',
  api_host: 'https://api-eu.mixpanel.com' 
});

if (window.user) {
  window.mixpanel.identify(window.user.firebase_user_id);
}

// Track page views on initial load
trackPageView();

// Track page views on Turbo navigation
document.addEventListener('turbo:load', () => {
  trackPageView();
});
